<template>
  <component
    :is="isList ? 'ul' : 'div'"
    :class="[
      'upsell-features w-full',
      isList ? 'flex flex-col gap-2' : 'grid gap-3 md:grid-cols-2',
    ]"
    :data-testid="isList ? 'upsell-feature-list' : 'upsell-feature-grid'"
  >
    <component
      :is="isList ? 'li' : OwnCard"
      v-for="feature in features"
      :key="feature.title"
      v-bind="isList ? {} : { radius: '16px' }"
      :class="
        isList
          ? 'upsell-features__row flex items-start gap-3'
          : 'upsell-features__card items-start gap-4 p-4'
      "
      :data-testid="`upsell-feature-${isList ? 'item' : 'card'}-${toTestId(feature.title)}`"
    >
      <span
        :class="[
          'upsell-features__icon',
          isList
            ? 'upsell-features__icon--list'
            : 'upsell-features__icon--grid',
        ]"
        aria-hidden="true"
      >
        <component
          :is="feature.icon ?? SparklesSoft"
          :size="isList ? 16 : 20"
        />
      </span>
      <div class="flex flex-col gap-1">
        <OwnType
          :text="feature.title"
          variant="title-small"
          :color="isList ? undefined : 'primary'"
        />
        <OwnType
          :text="feature.description"
          variant="paragraph-small"
          :color="isList ? 'secondary' : 'primary'"
        />
      </div>
    </component>
  </component>
</template>

<script lang="ts" setup>
import { SparklesSoft } from '@owner/icons-vue/SparklesSoft'
import { computed } from 'vue'

import { OwnCard } from '@/ui/OwnCard'
import { OwnType } from '@/ui/OwnType'

import type { UpsellFeature } from '../types'
import { toTestId } from '../utils'

const props = withDefaults(
  defineProps<{
    features: UpsellFeature[]
    /**
     * `grid` — two-column cards (full-page takeover). `list` — vertical white
     * rows (upsell modal).
     */
    variant?: 'grid' | 'list'
  }>(),
  {
    variant: 'grid',
  }
)

const isList = computed(() => props.variant === 'list')
</script>

<style lang="scss" scoped>
.upsell-features {
  &__row {
    padding: 12px;
    border-radius: 12px;
    background-color: var(--background-primary);
  }

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    // Warm tile from the tier-upgrades design — not a Hermes palette token.
    background-color: #f8f3ee;

    &--grid {
      border-radius: 12px;
    }

    &--list {
      border-radius: 10px;
    }
  }
}
</style>
